// Apply 심사한 심사역 목록

import React, { useEffect, useState } from "react";
// Components
import { SearchIcon } from "~/assets/svg/InterfaceIcon";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";

const JudgeParticipants = ({
    saveJudgeList,
    setChecked,
    checked,
    onChangeName,
                               setParticipantJudgeModal,
    judgeList,

    type="edit" // edit | view
}) => {
    const [
        {
            theme: { theme },
        },
    ] = useGlobalStore();
    const { t } = useTranslation();
    const [searchList, setSearchList] = useState([]);
    const [searchParam, setSearchParam] = useState("");

    const handleJudgeSearch = () => {
        if(searchParam === "") {
            setSearchList(judgeList);
        } else {
            const newList = judgeList.filter((item) => item?.user?.name.includes(searchParam));
            if(newList && newList?.length > 0) {
                setSearchList(newList)
            } else {
                setSearchList([]);
            }
        }
    }

    useEffect(() => {
        judgeList && setSearchList(judgeList);
    }, [judgeList])

    return (
        <>
            <div className="modal-content">
                <div className="table-top">
                    <div className="mem-total">
                        {`Total : ${judgeList?.length}
						${t("pages.apply.ApplyManage.Modal.JudgeListModal.judgeStandard")}`}
                    </div>
                    <div className="c__search">
                        <input
                            className="c__input"
                            placeholder="Search"
                            // onChange={onChangeName}
                            onChange={e => setSearchParam(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleJudgeSearch();
                                }
                            }}
                        />
                        <button
                            type="button"
                            className="btn-search"
                            onClick={() => handleJudgeSearch()}
                        >
                            <SearchIcon />
                        </button>
                    </div>
                </div>
                <div className="c__table teamInfo-table">
                    <div className="thead">
                        <div className="tr">
                            <div className="th img">
                                {t("pages.apply.ApplyManage.Modal.JudgeListModal.image")}
                            </div>
                            <div className="th name">
                                {t("pages.apply.ApplyManage.Modal.JudgeListModal.name")}
                            </div>
                            <div className="th position">
                                {t("pages.apply.ApplyManage.Modal.JudgeListModal.position")}
                            </div>
                            <div className="th email">
                                {t("pages.apply.ApplyManage.Modal.JudgeListModal.email")}
                            </div>
                        </div>
                    </div>
                    <div className="tbody">
                        {searchList?.map((item, idx) => {
                            return (
                                <div className="tr" key={idx}>
                                    <div className="td img">
                                        <div className="img-wrap">
                                            <img
                                                src={
                                                    item?.user?.img
                                                        ? item?.user?.img
                                                        : theme === "dark"
                                                            ? DarkDefaultProfileImg
                                                            : LightDefaultProfileImg
                                                }
                                                alt={t(
                                                    "pages.apply.ApplyManage.Modal.JudgeListModal.profile"
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className="td name">{item?.user?.name}</div>
                                    <div className="td position">
                                        {item?.user?.department &&
                                        item?.user?.position
                                            ? `${item?.user?.department || " - "}/${
                                                item?.user?.position || " - "
                                            }`
                                            : "-"}
                                    </div>
                                    <div className="td email">{item?.user?.id}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn__solid"
                    color="primary"
                    onClick={() => setParticipantJudgeModal(false)}
                >
                    확인
                </button>
            </div>
        </>
    );
};

export default JudgeParticipants;
